import React, { useEffect, useState } from 'react'
import volIcon from '../../Assets/Images/vol-icon.png'


export default function Volume({audio}) {
    const [vol,setVol]=useState(5)

    function volumeChange(e){
        setVol(e.target.value)
    }

    useEffect(()=>{
        audio.current.volume=vol/20
    },[vol,audio])

    return (
        <>
            <span id='volIi'><img id='volI' src={volIcon} alt='volume'/>
            <input type={'range'} id='volI' min={'0'} max={'20'} className='volume' value={vol} onChange={volumeChange}/></span>
        </>
    )
}
